import { useQuery } from "@tanstack/react-query";
import axios from "../axios-orders";
import { AnalyticsDashboardResponse, AnalyticsFilters } from "../types";
import { queryKeys } from "./queryKeys";

const fetchAnalyticsDashboard = async (
  filters: AnalyticsFilters
): Promise<AnalyticsDashboardResponse> => {
  const { data } = await axios.post("/analytics/dashboard", filters);
  return data;
};

export const useAnalyticsDashboard = (filters: AnalyticsFilters) =>
  useQuery<AnalyticsDashboardResponse, Error>({
    queryKey: [queryKeys.ANALYTICS_DASHBOARD, filters],
    queryFn: () => fetchAnalyticsDashboard(filters),
    enabled: !!filters.startDate && !!filters.endDate,
    placeholderData: (previous) => previous,
  });
